import {
    loading
} from '@/common/loading';
import {
    getCollectionTaskProList,
    checkLogin,
    getIssueRangeList,
    getCaseCountNew,
    getTaskNameList
} from '@/api/baseMsg';
import processPage from "@/components/processPage";
export default {
    name: "jiageshenheListNew",
    components: {
        processPage
    },
    data() {
        return {
            type: this.$route.query.type,
            // =========start======by wangry
            title: '自治区代填报',
            tableList: [],
            // active: 0,
            active: !Number(this.$route.query.active) ? 0 : Number(this.$route.query.active),
            startTime: this.$route.query.startTime ? this.$route.query.startTime : '',
            endTime: this.$route.query.endTime ? this.$route.query.endTime : '',
            // active2:  !Number(this.$route.query.active2)? 0: Number(this.$route.query.active2),
            active2: this.$route.query.active2 == 1 ? 1 : 0,
            loading1: false, //tabcard加载
            finished: false,
            todayCardList: [],//当日卡片列表
            allCardList: [],//全部卡片列表
            isBarNav: false,
            btnFlag: false,
            isBlue: 'blue2',//蓝色
            isGreen: 'green',//绿色
            isGrey: 'grey',//灰色
            isLoading: false,
            //===========end==========
            thisData: [],
            hbData: [],
            loginStatus: true,

            option1: [],
            option2: [],

            dscount: 0,//待审核
            dsNum: 0,

            // 2022-01-17新增
            dropdownTitle: "",//下拉展示标题
            dropdownInput: "",//搜索筛选框
            inputTable: [],//新数组作为筛选存储数组
            showDrop: false,//展示drop标记
            taskID: this.$route.query.taskID ? this.$route.query.taskID : '',
            stateId: this.$route.query.stateId ? this.$route.query.stateId : '',
        }
    },
    created() {
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        init() {
            loading(true);
            this.checkLogin();
            if (this.loginStatus) {
                this.getTaskNameList();
            }
        },
        // 获取任务列表
        getTaskNameList() {
            getTaskNameList({ taskCode: "", taskName: "", ordercol: "" }).then(res => {
                this.tableList = res;
                this.inputTable = res;
                // this.getCaseCount();
                this.getTodayCheckNew();
                this.getIssueRangeList();
            })
        },
        //价格采集和价格审核数量
        getCaseCount() {
            getCaseCountNew({
                taskCode: this.taskCode,
            }).then(res => {
                this.dsNum = res[3].unRFillCount;//待审核数量
                this.getTodayCheckNew();
            })
        },
        // 获取期号范围函数===wangry 2022-01-11
        getIssueRangeList() {
            getIssueRangeList({}).then(res => {
                res.forEach(i=> {
                    if(i.codeName == '全部') {
                        i.codeValue = ''
                    }
                    i.value = i.codeValue
                    i.text = i.codeName
                })
                this.option1 = res;
                this.option2 = res;
                this.endTime = this.$route.query.endTime ? this.$route.query.endTime : res[1].value
                this.startTime = this.$route.query.startTime ? this.$route.query.startTime : res[1].value
                
                
                this.getAllCheck();
            })
        },   
        //价格审核 houcc 2021.04.09 当日任务
        getTodayCheckNew() {
            getCollectionTaskProList({
                active: 0,
                taskCode: this.taskCode,
            }).then(res => {
                this.todayCardList = res.data;
                this.dscount = Number(res.data.length) - Number(this.dsNum)

                if(this.taskID && this.stateId) {
                    this.jump(this.taskID + this.stateId)
                }
                loading(false);
            })
        },
        jump(value){
            this.$nextTick(() => {
                setTimeout(() => {
                    document.getElementById(value).scrollIntoView({ behavior: "instant",block: "center", });
                })
            })
        },
        //全部任务
        getAllCheck() {
            loading(true)
            getCollectionTaskProList({
                active: 1,
                startTime: this.startTime,//开始时间
                endTime: this.endTime,//结束时间,
                taskCode: this.taskCode,
            }).then(res => {
                this.allCardList = res.data;
                loading(false);
            })
        },
        toList(item, index) {//跳转  价格采集页面
            var shispflag; //xianspflag 1蓝2绿3灰
            if (item.levelNum == 2 || item.levelNum == 3) {//省、市账户
                shispflag = item.shispflag;
            } else {//区县用户
                shispflag = item.xianspflag;
            }
            if (item.ifJCDApp == 1) {
                // this.$router.push({
                //     path: "/shengjiAgenFillLessNew",
                //     query: {
                //         taskCode: item.taskCode,
                //         exeno: item.exeno,
                //         ExeNo: item.ExeNo,
                //         taskId: item.taskID,
                //         shispflag: shispflag,
                //         shengspflag: item.shengspflag,
                //         ythflag: item.ythflag,
                //         levelNum: item.levelNum,
                //         active2: this.active2,
                //         index: index,
                //         priceDate: item.priceDate,
                //         lateReportTime: item.lateReportTime,
                //         stateId: item.stateId,
                //     },
                // });
                this.$router.push({
                path: '/shengjiAgenFillNew',
                query: {
                    taskCode: item.taskCode,
                    exeno: item.exeno,
                    ExeNo: item.ExeNo,
                    taskId: item.taskID,
                    shispflag: shispflag,
                    shengspflag: item.shengspflag,
                    ythflag: item.ythflag,
                    levelNum: item.levelNum,
                    active2: this.active2,
                    index: index,
                    priceDate: item.priceDate,
                    lateReportTime: item.lateReportTime,
                    stateId:item.stateId,
                    startTime: this.startTime,
                    endTime: this.endTime
                }
            });
            } else {
                this.$router.push({
                path: '/shengjiAgenFillNew',
                query: {
                    taskCode: item.taskCode,
                    exeno: item.exeno,
                    ExeNo: item.ExeNo,
                    taskId: item.taskID,
                    shispflag: shispflag,
                    shengspflag: item.shengspflag,
                    ythflag: item.ythflag,
                    levelNum: item.levelNum,
                    active2: this.active2,
                    index: index,
                    priceDate: item.priceDate,
                    lateReportTime: item.lateReportTime,
                    stateId:item.stateId,
                    startTime: this.startTime,
                    endTime: this.endTime
                }
            });
            }
            
        },
        navSwitch() {
            this.isBarNav = !this.isBarNav
        },

        //置顶图标
        backTop() {
            const that = this
            const timer = setInterval(() => {
                const ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onRefresh() {
            setTimeout(() => {
                this.isLoading = false;
                this.init();
            }, 300);
        },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        search() {
            this.getAllCheck();
        },
        onLoad() { //tabcard加载函数
            // 异步更新数据
            // setTimeout 仅做示例，真实场景中一般为 ajax 请求
            setTimeout(() => {
                // 加载状态结束
                this.loading1 = false;
                this.finished = true;
            }, 1000);
        },
        //监测登陆状态 houcc 2021.07.24
        checkLogin() {
            checkLogin({}).then(res => {
                if (!res.success) {
                    // nativeJSBridge.logout();
                    this.$router.push({ path: '/loginOld' });
                }
                this.loginStatus = res.success;
            })
        },

        fuzzyQuery(keyWord) {//搜索筛选方法
            if (keyWord.length == 0) {
                this.inputTable = this.tableList;
                return
            }
            const arr = [];
            for (let i = 0; i < this.tableList.length; i++) {
                if (this.tableList[i].taskName.indexOf(keyWord) >= 0) {
                    arr.push(this.tableList[i]);
                }
            }
            this.inputTable = arr;
        },
        dropClick(code, name) {
            //选择下拉列表点击事件
            this.dropdownInput = name;
            this.showDrop = !this.showDrop;
            // this.$refs.drop.toggle();
            this.taskCode = code;
            if (this.active === 0) {
                this.getCaseCount();
            } else if (this.active === 1) {
                this.getAllCheck();
            }
        },
        hideTabs() {//隐藏展示滚动tabs
            this.fuzzyQuery(this.dropdownInput);
            this.showDrop = true;
        },
        showTabs() {//展示滚动tabs
            this.showDrop = false;
        }
    },
    watch: {
        $route() {
            this.type = this.$route.query.type;
        },
    }
}